import { useButtonStyles } from './Button.styles';
import { jsx as _jsx } from "react/jsx-runtime";
const Button = ({
  label,
  children,
  variant,
  disabled,
  fullWidth = false,
  onClick,
  actionState = 'idle',
  allRequiredBindingsFilled = true
}) => {
  const isLoading = actionState === 'loading';
  const isDisabled = disabled || isLoading || !allRequiredBindingsFilled;
  const {
    baseStyle,
    styleMap
  } = useButtonStyles({
    isDisabled,
    fullWidth
  });
  return /*#__PURE__*/_jsx("button", {
    "aria-label": children ? label : undefined,
    style: Object.assign({}, baseStyle, styleMap[variant !== null && variant !== void 0 ? variant : 'primary']),
    onClick: onClick,
    disabled: isDisabled,
    children: children !== null && children !== void 0 ? children : label
  });
};
export default Button;